<template lang="pug" src="./photo-report-create.pug"> </template>
<style lang="scss" src="./photo-report-create.scss" scoped> </style>

<script>

import { validationMixin } from 'vuelidate';
import validate from '@/mixins/validate';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapState, mapGetters } from 'vuex';
import { getFormData } from '@/utils/helpers';
import uploadCsv from '@/components/upload-csv';
import config from '../../../../../config.json';

export default {
    components: {
        'v-upload-csv': uploadCsv
    },
    mixins: [validationMixin, validate],
    data: () => ({
        formData: null,
        filters: {
            mode: 'brand',
            reasonId: null,
            name: null,
            brandId: null,
            commissionId: null,
            optionClassId: null,
            callSigns: null,
            csvFile: null
        },
        checking: {
            checkCallSign: null
        },
        infoDialog: false,
        commissionSearch: '',
        useCsv: config.photoReport.useCsv
    }),
    validations: {
        filters: {
            name: {
                required
            },
            reasonId: {
                required
            },
            brandId: {
                required: requiredIf(function() {
                    return this.filters.mode == 'brand';
                })
            },
            callSigns: {
                required: requiredIf(function() {
                    return this.filters.mode == 'callSign' && !this.filters.csvFile;
                })
            },
        },
        checking: {
            checkCallSign: {
                required
            }
        }
    },
    computed: {
        ...mapGetters(['userBrandId']),
        ...mapState({
            reasons: (state) => {
                return state.photoReasons.reasons.map(it => ({
                    name: `${it.name} ( ${it.types.map(it => it.name).join(', ')} )`,
                    id: it.id
                }));
            },
            brands: (state) => state.data.brands,
            optionClasses: (state) => state.data.optionClasses,
            commissions: (state) => state.data.driverCommissions,
            checkDrivers: (state) => state.photoReports.checkDrivers
        }),
        modes() {
            return ['brand', 'callSign'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.PhotoReport.requestCreate.filters.${it}`),
                value: it
            }));
        },
        isShowCheck() {
            return this.filters.mode === 'callSign' && this.checkDrivers;
        },
        validation() {
            return [
                { icon: 'mdi-checkbox-marked-circle-outline', name: 'success' },
                { icon: 'mdi-file-cancel-outline', name: 'notFound' },
                { icon: 'mdi-content-duplicate', name: 'duplicate' },
                { icon: 'mdi-note-text', name: 'inOpenRequest' },
                { icon: 'mdi-cancel', name: 'validationError' }
            ].map(it => ({
                title: this.$vuetify.lang.t(`$vuetify.pages.PhotoReport.validation.${it.name}`),
                name: it.name,
                icon: it.icon
            }));
        }
    },
    created: function() {
        if (this.userBrandId) {
            this.filters.brandId = this.userBrandId;
        }

        this.$store.dispatch('photoReasons/getAllReasons');
        this.$store.dispatch('data/getBrands');
        this.$store.dispatch('data/getOptionClasses');
        this.loadDriverCommissions();
    },
    methods: {
        loadDriverCommissions() {
            this.$store.dispatch('data/getDriverCommissions', {
                brandIds: JSON.stringify([this.filters.brandId])
            });
        },

        changeBrand(brandId) {
            this.filters.commissionId = null;
            this.filters.brandId = brandId;

            this.loadDriverCommissions();
        },

        onAutocompleteChange: function(key, value) {
            this.$set(this.filters, key, value);
        },

        onModsChange() {
            this.$store.commit('photoReports/SET_DRIVERS', null);
            this.resetData();
        },

        onFileSelect(file) {
            this.$store.commit('photoReports/SET_DRIVERS', null);
            this.filters.csvFile = file;
        },

        onCallSignsChange() {
            this.$store.commit('photoReports/SET_DRIVERS', null);
        },

        openInfoDialog() {
            if (this.$v.filters.$invalid) {
                this.$v.filters.$touch();
                this.focusFirstErrorInput();
                return;
            }

            this.infoDialog = true;
        },

        createRequestReport() {
            this.$v.$reset();

            this.formData = getFormData(this.formatData());
            this.$store.dispatch('photoReports/requestReportCreate', this.formData);
            this.$store.commit('photoReports/SET_DRIVERS', null);
            this.resetData(true);

            this.$nextTick(() => {
                this.infoDialog = false;
            });
        },

        async checkCallSigns() {
            this.$v.$reset();

            if (this.$v.filters.$invalid) {
                this.$v.filters.$touch();
            } else {
                this.formData = getFormData(this.formatData());
                await this.$store.dispatch('photoReports/requestReportCheck', this.formData);
                window.scrollTo({ top: 1000, behavior: 'smooth' });
            }
        },

        resetData(isCreated = false) {
            this.filters = {
                ...this.filters,
                reasonId: isCreated ? null : this.filters.reasonId,
                name: isCreated ? null : this.filters.name,
                brandId: null,
                commissionId: null,
                optionClassId: null,
                callSigns: null,
                csvFile: null,
                checkCallSign: null
            };
            this.checking = {
                checkCallSign: null
            };
            this.$v.$reset();
        },

        formatData(isCheck = false) {
            return {
                ...this.filters,
                callSigns: this.filters.callSigns && JSON.stringify(this.filters.callSigns.split(',')),
                checkCallSign: isCheck ? this.checking.checkCallSign : null
            };
        }
    }
};
</script>
